import api from "./api";

export const getAllDepartments = async () => {
  const res = await api.get("/BookingDetails/GetDepartmentDetails");
  const data = res?.data;
  let list = [];
  if (Array.isArray(data)) list = data;
  else if (Array.isArray(data?.resultSet)) list = data.resultSet;

  // normalize to { id, name, code, status }
  return list.map((d) => {
    return {
      id: d.DepartmentID || d.Id || d.id || d.departmentId || 0,
      code: d.Dcode || d.code || d.departmentCode || d.DepartmentCode || "",
      name:
        d.DepartmentName || d.Dname || d.Name || d.name || d.deptName || d.departmentName || "",
      status: d.status || d.Status || "A",
      // keep original in case other info is needed
      raw: d,
    };
  });
};

export const postDepartment = async (dept) => {
  const payload = [
    {
      Dcode: dept.code,
      Dname: dept.name,
      status: dept.status || "A",
    },
  ];
  const res = await api.post("/BookingDetails/PostDepartment", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export default {
  getAllDepartments,
  postDepartment,
};
